import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 28,
	viewBox: "0 0 29 28",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.52192 21.9626L6.25317 20.7376L13.2313 14.0001L6.25317 7.2626L7.52192 6.0376L14.5 12.7751L21.4782 6.0376L22.7469 7.2626L15.7688 14.0001L22.7469 20.7376L21.4782 21.9626L14.5 15.2251L7.52192 21.9626Z",
		fill: "white"
	})
});
export default SvgCloseWhite;
